module.exports = __webpack_public_path__ + "static/img/celoscope-21.30b39bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-21.jpg
// module id = BU1w
// module chunks = 52